import React from 'react';
import { Link } from 'react-router-dom';
import { STUDIO_MARK } from '@/data/studio';

export default function FinalCTAPremium() {
  return (
    <section id="final-cta" className="relative bg-[#F8F4EC] py-16 sm:py-24 lg:py-28 border-t border-[#1A1814]/10 overflow-hidden">
      <div
        aria-hidden
        className="hidden lg:block pointer-events-none absolute select-none font-display-italic text-[#0A1A2F]/[0.04]"
        style={{
          fontSize: 'clamp(360px, 38vw, 560px)',
          right: '-4vw',
          bottom: '-12vh',
          lineHeight: 1,
          letterSpacing: '-0.05em',
        }}
      >
        {STUDIO_MARK}.
      </div>

      <div
        className="relative max-w-[1100px] mx-auto px-6 sm:px-10 md:px-14 lg:px-20 py-16 sm:py-20 text-center rounded-[28px] overflow-hidden"
        style={{
          background: 'rgba(255,255,255,0.55)',
          backdropFilter: 'blur(18px) saturate(140%)',
          WebkitBackdropFilter: 'blur(18px) saturate(140%)',
          border: '1px solid rgba(255,255,255,0.6)',
          boxShadow: '0 24px 60px -40px rgba(10,26,47,0.25)',
        }}
      >
        <span
          aria-hidden
          className="pointer-events-none absolute inset-x-0 top-0 h-px"
          style={{ background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.85), transparent)' }}
        />
        <div className="font-mono-label text-[10px] sm:text-[11px] text-[#C5A059] mb-8">
          Start the conversation
        </div>

        <h2
          className="font-display text-[#1A1814] mx-auto"
          style={{
            fontSize: 'clamp(40px, 6.5vw, 88px)',
            lineHeight: 1.0,
            letterSpacing: '-0.03em',
            textWrap: 'balance',
            maxWidth: '18ch',
          }}
        >
          See your site{' '}
          <span style={{ color: '#C5A059' }}>redesigned.</span>
        </h2>

        <p
          className="text-[#3F3A30] mx-auto mt-10 max-w-[52ch]"
          style={{ fontSize: 'clamp(18px, 2vw, 22px)', lineHeight: 1.55 }}
        >
          Send us the address. We will send back a redesign of it, built and live. Nothing to
          commit to, and we reply personally.
        </p>

        <div className="mt-12 sm:mt-14 flex flex-col items-center gap-5">
          <Link
            to="/contact"
            className="group inline-flex w-full sm:w-auto items-center justify-center px-7 sm:px-14 py-5 sm:py-[22px] bg-[#0A1A2F] text-[#F8F4EC] text-center text-[13px] sm:text-[14px] font-semibold tracking-[0.2em] uppercase rounded-sm hover:bg-[#C5A059] transition-colors duration-300"
            style={{ boxShadow: '0 22px 44px -16px rgba(10, 26, 47, 0.4)' }}
          >
            <span>Send us your site</span>
            <span aria-hidden className="ml-3 transition-transform duration-300 group-hover:translate-x-1">→</span>
          </Link>
          <p className="text-[#9A9384] text-[13px] sm:text-[14px] tracking-wide">
            A small number of clients at a time. A few slots open.
          </p>
        </div>
      </div>
    </section>
  );
}
